import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useInstallPrompt } from "@/hooks/use-install-prompt";

interface Props {
  className?: string;
  variant?: "default" | "outline" | "secondary" | "ghost";
  size?: "default" | "sm" | "lg" | "icon";
  fullWidth?: boolean;
}

export function InstallAppButton({
  className,
  variant = "outline",
  size = "sm",
  fullWidth = false,
}: Props) {
  const { canInstall, install } = useInstallPrompt();

  if (!canInstall) return null;

  return (
    <Button
      type="button"
      variant={variant}
      size={size}
      onClick={() => install()}
      className={`cursor-pointer ${fullWidth ? "w-full" : ""} ${className ?? ""}`}
      data-testid="button-install-app"
    >
      <Download className="w-4 h-4 mr-2" />
      Instalar esse Aplicativo
    </Button>
  );
}
